module.exports = __webpack_public_path__ + "static/media/joke-api.7395dc8b.png";